import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Info, Shield } from 'lucide-react';
import Header from '../components/landing/Header';
import Footer from '../components/landing/Footer';
import { useScrollToTop } from '../hooks/useScrollToTop';

const Disclaimer: React.FC = () => {
  useScrollToTop();
  
  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      
      <div className="flex-grow py-12 bg-gray-50">
        <div className="container mx-auto px-4 max-w-4xl">
          <div className="bg-white rounded-lg shadow-sm p-8">
            <Link 
              to="/"
              className="inline-flex items-center text-gray-600 hover:text-gray-900 mb-6"
            >
              <ArrowLeft className="h-4 w-4 mr-2" />
              Back to Home
            </Link>

            <div className="flex items-center mb-6">
              <Shield className="h-8 w-8 text-[#7B4AE2] mr-3" />
              <h1 className="text-3xl font-bold text-gray-900">Disclaimer</h1>
            </div>
            
            <div className="bg-[#F0E9FF] border border-[#E0D9FF] rounded-lg p-6 mb-8">
              <div className="flex items-start">
                <Info className="h-5 w-5 text-[#7B4AE2] mt-0.5 mr-2 flex-shrink-0" />
                <p className="text-[#7B4AE2] font-medium">
                  11thadmission.com is an independent educational consulting service and is not affiliated with, endorsed by, or connected to any government body, educational institution, or admissions authority. We do not control, influence, or make decisions regarding any admission processes. Our services are limited to providing guidance and support only.
                </p>
              </div>
            </div>
            
            <div className="prose max-w-none">
              <section className="mb-8">
                <h2 className="text-xl font-semibold text-gray-900 mb-4">Independent Service</h2>
                <p className="text-gray-600 mb-4">
                  11thadmission.com is an independent educational consulting service and is not affiliated with, endorsed by, or connected to any government body, educational institution, or admissions authority. We do not control, influence, or make decisions regarding any admission processes. Our services are limited to providing guidance and support only.
                </p>
                <p className="text-gray-600 mb-4">
                  All admission decisions are made solely by the respective educational institutions and their designated admissions committees. We cannot guarantee admission to any institution, and any suggestions or advice provided are based on our experience but do not represent official positions of any educational institution or governing body.
                </p>
              </section>

              <section className="mb-8">
                <h2 className="text-xl font-semibold text-gray-900 mb-4">No Guarantees</h2>
                <p className="text-gray-600 mb-4">
                  By using our services, you acknowledge and agree that 11thadmissions.com shall not be held liable for any admission decisions, application outcomes, or related consequences. We make no warranties, expressed or implied, regarding admission results or acceptance to any educational institution.
                </p>
                <p className="text-gray-600 mb-4">
                  Our predictions and guidance are generated using historical data and advanced algorithmic models, which currently demonstrate an accuracy rate of over 90%. While we continuously update and refine these models for better performance, all predictions are indicative and do not guarantee actual admission outcomes.
                </p>
              </section>

              <section className="mb-8">
                <h2 className="text-xl font-semibold text-gray-900 mb-4">Accuracy of Information</h2>
                <p className="text-gray-600 mb-4">
                  While we strive to provide accurate and up-to-date information, we cannot guarantee the complete accuracy, reliability, or timeliness of the information presented on our platform. Educational policies, admission criteria, cutoffs, and other relevant information may change without notice.
                </p>
                <p className="text-gray-600 mb-4">
                  Users are strongly encouraged to verify all information directly with the respective educational institutions or official government sources before making any decisions based on the information provided on our platform.
                </p>
              </section>

              <section className="mb-8">
                <h2 className="text-xl font-semibold text-gray-900 mb-4">Limitation of Liability</h2>
                <p className="text-gray-600 mb-4">
                  Cutoffs and trends may vary each year due to multiple factors beyond our control. 11thadmissions.com and its affiliates shall not be held liable for any decisions made based on the predictive outputs provided by the platform. Users are encouraged to use their own discretion and consult official sources when making admission-related choices.
                </p>
                <p className="text-gray-600 mb-4">
                  To the fullest extent permitted by applicable law, 11thadmissions.com and its owners, directors, officers, employees, agents, partners, and licensors shall not be liable for any direct, indirect, incidental, special, consequential, or exemplary damages resulting from your use of our services.
                </p>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-gray-900 mb-4">Contact Information</h2>
                <p className="text-gray-600">
                  If you have any questions about this disclaimer, please contact us at:
                  <br />
                  Email: info@11thadmissions.com
                </p>
              </section>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default Disclaimer;